import ResetMap from 'components/Icons/ResetMap';
import { IconButton } from 'components/lib';
import React, { FC } from 'react';

type Props = {
  id?: string;
  disable?: boolean;
  handleCenterMap: () => void;
  style?: React.CSSProperties;
};

const CenterMapButton: FC<Props> = ({
  id,
  handleCenterMap,
  style,
  disable,
}: Props) => {
  return (
    <>
      <IconButton
        id={`${id}-reset-map`}
        aria="Reset map"
        size="large"
        type="button"
        disabled={disable}
        variant="fab"
        onClick={handleCenterMap}
        css={{
          bottom: 144,
          borderBottom: '0.5px solid #e8ebf0',
          left: 17,
          position: 'absolute',
          ...style,
        }}
      >
        <ResetMap />
      </IconButton>
    </>
  );
};

export default CenterMapButton;
